module.exports = __webpack_public_path__ + "static/media/md-film.8c95b411.svg";